import { useNavigate, useParams } from 'react-router-dom';
import { Typography } from '../../../../core/components/molecules/Typography';
import { Fragment, useEffect } from 'react';
import { useModule } from '../../hooks/useModule';
import { useSubjectSeen } from '../../hooks/useSubjectSeen';
import { disciplines, disciplinesWhiteList, universityDisciplines } from '../../utils/disciplineHelper';
import { IModules } from '../../../../core/models/disciplines';
import Container from '../../../../core/components/atoms/Container';
import PageHeader from '../../../../core/components/molecules/Header';
import ContentLoader from 'react-content-loader';
import IconCard from '../../../../core/components/organism/IconCard';
import { Card } from '../../../../core/components/organism/IconCard/variants';
import { VariantProps } from 'tailwind-variants';
import { getDisciplineName } from '../../../../core/utils/discipline';
import { useExerciseStore } from '../../stores/exercisesStore';

export default function ModulosPage() {
  const navigate = useNavigate();
  const { discipline } = useParams();

  const setFavorite = useExerciseStore.getState().setFavorite;

  const { mutate, isPending, data } = useModule();
  const { data: subjectSeen } = useSubjectSeen(discipline);

  useEffect(() => {
    if (discipline) {
      setFavorite(false);
      mutate(discipline);
    }
  }, [discipline]);

  useEffect(() => {
    if (!disciplinesWhiteList.includes(discipline as string)) {
      navigate('/error');
    }
  }, [discipline]);

  const isUniversityDiscipline = universityDisciplines.some(
    (it) => it.slug === discipline,
  );
  const disciplineList = isUniversityDiscipline ? universityDisciplines : disciplines;

  const handleSelect = (module: IModules) => {
    if(module) {
      navigate(`/disciplinas/${discipline}/modulo/${module.slug}/tipo/videoaula`)
    }
  }

  if (!disciplinesWhiteList.includes(discipline as string)) {
    return null;
  }

  return (
    <Container direction='col' gap='xl'>
      <div className='flex flex-col justify-between md:flex-row md:items-end'>
        <PageHeader
          module='Disciplina'
          title={
            disciplineList.find((it) => it.slug === discipline)?.label ||
            getDisciplineName(discipline ?? '') ||
            ''
          }
          isDropdown
          dropdownItems={disciplineList}
        />
      </div>
      {isPending ? (
        <div className='grid xs:grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-lg'>
          {Array.from({ length: 12 }, (_, i) => (
            <ContentLoader
              key={i}
              backgroundColor={'#a7adba'}
              foregroundColor={'#c0c5ce'}
              viewBox='0 0 300 350'
            >
              <rect x='0' y='2' rx='2' ry='2' width="100%" height='100%' />
            </ContentLoader>
          ))}
        </div>
      ) : (
        <Fragment>
          <Typography size='h6' type='titleSection'>
            MÓDULOS
          </Typography>
          <div className='grid gap-lg xs:grid-cols-1 md:grid-cols-3 lg:grid-cols-4'>
            {data && data.length > 0 && data.map((it, i) => (
              <IconCard
                key={i}
                title={it.title}
                description={it.description}
                subjects={it.subject.length}
                slug={discipline || ''}
                color={discipline as VariantProps<typeof Card>['color']}
                type='modules'
                iconSVG={it.iconSVG}
                action={() => handleSelect(it)}
                progress={subjectSeen[it._id]}
              />
            ))}
          </div>
        </Fragment>
      )}
    </Container>
  );
}
